class StoryTimelineDisclosure extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.buttons = Array.from(this.querySelectorAll('[data-timeline-button]'));
    this.panels = Array.from(this.querySelectorAll('[data-timeline-panel]'));
    this.handleClick = this.handleClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleBlockSelect = this.handleBlockSelect.bind(this);

    this.addEventListener('click', this.handleClick);
    this.addEventListener('keydown', this.handleKeydown);

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('keydown', this.handleKeydown);
    document.removeEventListener('shopify:block:select', this.handleBlockSelect);
  }

  handleClick(event) {
    const button = event.target.closest('[data-timeline-button]');
    if (!button || !this.contains(button)) return;

    const shouldExpand = this.hasAttribute('data-persistent') || button.getAttribute('aria-expanded') !== 'true';
    this.setExpanded(button, shouldExpand);
  }

  handleKeydown(event) {
    const button = event.target.closest('[data-timeline-button]');
    if (!button || !this.contains(button)) return;

    const currentIndex = this.buttons.indexOf(button);
    let nextIndex;

    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.buttons.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.buttons.length) % this.buttons.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.buttons.length - 1;
    if (nextIndex === undefined) return;

    event.preventDefault();
    this.buttons[nextIndex].focus();
    this.setExpanded(this.buttons[nextIndex], true);
  }

  handleBlockSelect(event) {
    const button = this.buttons.find(
      (item) => item.closest('[data-block-id]')?.dataset.blockId === event.detail.blockId
    );

    if (button) this.setExpanded(button, true);
  }

  setExpanded(activeButton, shouldExpand) {
    this.buttons.forEach((button) => {
      const isActive = button === activeButton && shouldExpand;
      const panel = this.querySelector(`#${button.getAttribute('aria-controls')}`);

      button.setAttribute('aria-expanded', String(isActive));
      if (panel) panel.hidden = !isActive;
    });
  }
}

if (!customElements.get('story-timeline-disclosure')) {
  customElements.define('story-timeline-disclosure', StoryTimelineDisclosure);
}
